import React from 'react'
import { FiUser, FiDollarSign, FiBarChart, FiHelpCircle, FiSettings,  FiLogOut } from 'react-icons/fi'

export const AuthList = () => {
    return (
            <ul>
                <li><a href="/account"><FiUser /> Account</a></li>
                <li><a href="/account/payment"><FiDollarSign /> Billing</a></li>
                <li><a href="/#"><FiBarChart /> Analytics</a></li>
                <li><a href="/account/setting"><FiSettings /> Settings</a></li>
                <li className="line"></li>
                <li><a href="/#"><FiHelpCircle /> Help</a></li>
                <li ><a href="/#"><FiLogOut /> Logout</a></li>
            </ul>
    )
}